import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import * as React from "react";

import {
  getMonthlyTargetWorkLocation,
  importMonthlyTarget,
} from "@/fetch/fetchTarget";
import Box from "@mui/material/Box";
import FormHelperText from "@mui/material/FormHelperText";
import Stack from "@mui/material/Stack";
import _ from "lodash";

export default function CreateSystemSettingWorkDialog(props) {
  const {
    datetime,
    open,
    onClose,
    setSnackMessage,
    setSnackOpen,
    setSnackSeverity,
    fetchAll,
    productData,
  } = props;

  const [shopLists, setShopLists] = React.useState([]);
  const [selectedShopValue, setSelectedShopValue] = React.useState({
    target_total_amount: "",
    is_active: "",
    street: "",
  });
  const [formValidation, setFormvalidation] = React.useState({
    target_total_amount: false,
    is_active: false,
    street: false,
  });

  const getShop = async () => {
    const { data } = await getMonthlyTargetWorkLocation();
    if (data.length > 0) {
      setShopLists(data);
    }
  };

  const headers = [
    { label: "id", key: "id" },
    { label: "店舖編號", key: "work_shortcode" },
    { label: "店舖名稱", key: "work_name" },
    { label: "店舖地區", key: "work_district" },
    { label: "店舖地址", key: "work_address" },
    { label: "店舖電話", key: "work_telephone" },
    { label: "Region", key: "region_name" },
    { label: "Area", key: "area_name" },
    { label: "District", key: "district_name" },
    { label: "target_total_amount", key: "" },
    { label: "is_active", key: "" },
  ];

  const handleShopOnChange = (event) => {
    setSelectedShopValue((prev) => ({
      ...prev,
      ...shopLists[event.target.value],
      target_total_amount: 0,
      is_active: "",
      street: "",
    }));
  };

  const handleTargetAmountChange = (event) => {
    setSelectedShopValue((prev) => ({
      ...prev,
      target_total_amount: event.target.value,
    }));
  };

  const handleStreetChange = (event) => {
    setSelectedShopValue((prev) => ({
      ...prev,
      street: event.target.value,
    }));
  };

  const handleActiveChange = (event) => {
    setSelectedShopValue((prev) => {
      let tempActiveValue = false;
      if (event.target.value === "開啟") {
        tempActiveValue = true;
      }
      return (prev = { ...prev, is_active: tempActiveValue });
    });
  };

  const onSubmit = async () => {
    const checkIsDuplicate = () => {
      const obj = productData.find((item) => item.id === selectedShopValue.id);
      return obj ? true : false;
    };

    const checkIsError = () => {
      const isActive =
        ["", 0, " "].some((item) => selectedShopValue.is_active === item) &&
        "請選擇狀態";

      const isValidAmount =
        ["", " "].some(
          (item) => selectedShopValue.target_total_amount === item
        ) && "目標總額不能為空";

      return { isValidAmount, isActive };
    };

    const invalid = checkIsError();

    setFormvalidation({
      target_total_amount: invalid.isValidAmount,
      is_active: invalid.isActive,
    });

    if (invalid.isActive || invalid.isValidAmount) {
      return false;
    } else if (checkIsDuplicate()) {
      setSnackMessage("記錄已存在");
      setSnackSeverity("error");
      setSnackOpen(true);
    } else {
      try {
        const { data } = await importMonthlyTarget(datetime, [
          selectedShopValue,
        ]);
        if (data.length > 0) {
          setSnackMessage("新增成功");
          setSnackSeverity("success");
          setSnackOpen(true);
          fetchAll();
        }
      } catch (err) {
        setSnackMessage("新增失敗");
        setSnackSeverity("error");
        setSnackOpen(true);
      } finally {
        onClose();
      }
    }
  };

  React.useEffect(() => {
    getShop();
  }, []);

  return (
    <Dialog
      open={open}
      onClose={() => {
        setSelectedShopValue({
          target_total_amount: "",
          is_active: "",
        });
        onClose();
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="md"
    >
      <Box sx={{ mt: 2 }} />
      <DialogTitle>
        <Stack direction="row" justifyContent={"space-between"}>
          <div style={{ width: "70%" }}>新增銷售總額</div>
          <div style={{ width: "30%" }}>
            <FormControl fullWidth>
              <InputLabel id="select-brands-label">店舖編號</InputLabel>
              <Select
                required
                id="brand"
                name="brand"
                label="Brand"
                labelId="select-brands-label"
                value={selectedShopValue.work_shortcode}
                onChange={handleShopOnChange}
              >
                <MenuItem disabled>請選擇</MenuItem>
                {_.map(shopLists, (item, key) => (
                  <MenuItem key={key} value={key}>
                    {item.work_shortcode}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </Stack>
      </DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <Box
          component="form"
          noValidate
          sx={{
            display: "grid",
            gridTemplateColumns: { sm: "1fr 1fr" },
            gap: 2,
          }}
        >
          {shopLists.length > 0 &&
            Object.keys(shopLists[0])
              .filter(
                (item) =>
                  item !== "work_shortcode" &&
                  item !== "id" &&
                  item !== "time_created"
              )
              .map((item, index) => {
                const foundHeader = headers.find(
                  (header) => header.key === item
                );
                if (foundHeader) {
                  return (
                    <FormControl key={index} fullWidth>
                      <TextField
                        disabled={selectedShopValue[item] ? false : true}
                        id={item}
                        name={item}
                        label={foundHeader.label}
                        value={selectedShopValue[item] || ""}
                        InputProps={{
                          readOnly: true,
                        }}
                      ></TextField>
                    </FormControl>
                  );
                }
                return <></>;
              })}
          <FormControl fullWidth>
            <TextField
              disabled={selectedShopValue.id ? false : true}
              error={!!formValidation.target_total_amount}
              helperText={formValidation.target_total_amount}
              required
              id="target_total_amount"
              name="target_total_amount"
              label="目標總額"
              type="number"
              value={selectedShopValue.target_total_amount}
              onChange={handleTargetAmountChange}
            ></TextField>
          </FormControl>
          <FormControl fullWidth>
            <TextField
              disabled={selectedShopValue.id ? false : true}
              error={!!formValidation.street}
              helperText={formValidation.street}
              id="street"
              name="street"
              label="Street"
              type="text"
              value={selectedShopValue.street}
              onChange={handleStreetChange}
            ></TextField>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel
              error={!!formValidation.is_active}
              id="select-brands-label"
            >
              狀態
            </InputLabel>
            <Select
              disabled={selectedShopValue.id ? false : true}
              required
              id="is_active"
              name="is_active"
              label="Brand"
              labelId="select-brands-label"
              defaultValue="請選擇"
              value={
                selectedShopValue.is_active === ""
                  ? "請選擇"
                  : selectedShopValue.is_active === true
                  ? "開啟"
                  : "關閉"
              }
              onChange={handleActiveChange}
            >
              <MenuItem disabled value={"請選擇"}>
                請選擇
              </MenuItem>
              {["開啟", "關閉"].map((item, index) => (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText error={!!formValidation.is_active}>
              {formValidation.is_active}
            </FormHelperText>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setSelectedShopValue({
              target_total_amount: "",
              is_active: "",
            });
            onClose();
          }}
        >
          取消
        </Button>
        <Button onClick={onSubmit} type="submit">
          新增
        </Button>
      </DialogActions>
    </Dialog>
  );
}
